export default __webpack_public_path__ + "static/media/ActiveHeaderPhone.296f34eb.svg";